import { service } from '../axios';
/* 保存耗材入库单（新增 / 修改）*/
export function saveConsStockIn(data) {
    return service({
        url: '/cons/stock/save',
        method: 'post',
        data
    });
}
/*根据入库单号查询入库单详情*/
export function getConsStockInDetail(params) {
    return service({
        url: '/cons/stock/detail',
        method: 'get',
        params
    });
}
/* 保存耗材入库单（新增 / 修改）*/
export function saveConsStockOut(data) {
    return service({
        url: '/cons/stockOut/save',
        method: 'post',
        data
    });
}
/*根据入库单号查询入库单详情*/
export function getConsStockOutDetail(params) {
    return service({
        url: '/cons/stockOut/detail',
        method: 'get',
        params
    });
}
export function outConsStockApplyBound(data) {
    return service({
        url: '/cons/stock/outApplyBound',
        method: 'post',
        data
    });
}
export function outConsStockCanncelApply(data) {
    return service({
        url: '/cons/stock/cancelStockByApply',
        method: 'post',
        data
    });
}
export function checkPickApplyByStockBatchCode(data) {
    return service({
        url: '/cons/stock/checkPickApplyByStockBatchCode',
        method: 'post',
        data
    });
}
export function checkFreeByStockBatchCode(data) {
    return service({
        url: '/cons/stock/checkFreeByStockBatchCode',
        method: 'post',
        data
    });
}
export function outFreeByStockBatchCode(data) {
    return service({
        url: '/cons/stock/outFreeByStockBatchCode',
        method: 'post',
        data
    });
}
export function saveConsUsage(dto) {
    return service({
        url: '/cons/usage/saveUsage',
        method: 'post',
        data: dto
    });
}
export function getConsReturnableList(params) {
    return service({
        url: '/cons/usage/returnable',
        method: 'get',
        params
    });
}
export function saveConsReturn(dto) {
    return service({
        url: '/cons/usage/saveReturn',
        method: 'post',
        data: dto
    });
}
export function confirmStockReturn(dto) {
    return service({
        url: '/cons/usage/confirmStockReturn',
        method: 'post',
        data: dto
    });
}
export function cancelStockReturn(dto) {
    return service({
        url: '/cons/usage/cancelStockReturn',
        method: 'post',
        data: dto
    });
}
export function userCancelStockReturn(dto) {
    return service({
        url: '/cons/usage/userCancelStockReturn',
        method: 'post',
        data: dto
    });
}
export function getFutureStockCompare() {
    return service({
        url: '/cons/home/getFutureStockCompare',
        method: 'get',
    });
}
